module.exports = __webpack_public_path__ + "static/media/1.e97c35d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/1.png
// module id = 375
// module chunks = 0